/* eslint-disable react-refresh/only-export-components --
 * Context module: subtree wrapper + hook are intentionally co-located.
 */
import React, { createContext, useContext } from 'react';

const ControlDisabledContext = createContext(false);

export function useControlDisabled(): boolean {
  return useContext(ControlDisabledContext);
}

/**
 * Stacks with parent disabled state: `effective = parentDisabled || disabled`.
 */
export function ControlDisabledSubtree({
  disabled,
  className,
  children,
}: {
  disabled: boolean;
  className?: string;
  children: React.ReactNode;
}) {
  const parentDisabled = useControlDisabled();
  const effective = parentDisabled || disabled;
  const subtree = (
    <ControlDisabledContext.Provider value={effective}>
      {children}
    </ControlDisabledContext.Provider>
  );
  return className ? <div className={className}>{subtree}</div> : subtree;
}
